import * as xml2js from "xml2js";

const fetchExternalProducts = (xmlFile, successHandler, errorHandler, category) => {
  // TODO load XML remotely via firebase function

  fetch(xmlFile)
    .then(response => {
      return response.text();
    })
    .then(responseText => {
      xml2js.parseString(responseText, (err, result) => {
        if (!err && result.SHOP && result.SHOP.SHOPITEM) {
          successHandler(result.SHOP.SHOPITEM, category);
        } else {
          errorHandler({ message: "Něco se nepovedlo", err, result })
        }
      });
    })
    .catch(err => {
      errorHandler({ message: "Ajaj, nepovedlo se načíst produkty", err });
      console.log(err);
      }
    );
};


const fetchProducts = (success, error) => {

  const sestavyXML = process.env.NODE_ENV === 'development' ?
  process.env.PUBLIC_URL + "/productsSestavy.xml"
  : 'https://eshop.destovka.eu/export/productsComplete.xml?patternId=-5&hash=f80a4bdcbb6cc380345bed198b84e6532f20e136413514d6121de455dfaca53f&categoryId=816';
  const nadrzeNadzemniXML = process.env.NODE_ENV === 'development' ?
  process.env.PUBLIC_URL + "/productsNadrzeNadzemni.xml"
  : 'https://eshop.destovka.eu/export/productsComplete.xml?patternId=-5&hash=f80a4bdcbb6cc380345bed198b84e6532f20e136413514d6121de455dfaca53f&categoryId=757';
  const nadrzePodzemniXML = process.env.NODE_ENV === 'development' ?
  process.env.PUBLIC_URL + "/productsNadrzePodzemni.xml"
  : 'https://eshop.destovka.eu/export/productsComplete.xml?patternId=-5&hash=f80a4bdcbb6cc380345bed198b84e6532f20e136413514d6121de455dfaca53f&categoryId=706';

  fetchExternalProducts(nadrzePodzemniXML,success,error,'podzemni');
  fetchExternalProducts(nadrzeNadzemniXML,success,error,'nadzemni');
  fetchExternalProducts(sestavyXML,success,error,'sestavy');
}

export default fetchProducts;
